import { ErrorPalette } from '@tcl-boron-colors/colors';
import { Fail } from '@tcl-boron-icons/icons';
import { Button } from '@tcl-boron-prefabs/button';
import { createUseStyles } from 'react-jss';

export const useErrorStyles = createUseStyles({
  errorContainer: {
    marginTop: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
    padding: '16px',
  },
  errorText: {
    margin: 0,
    fontSize: '16px',
    fontWeight: '500',
    textAlign: 'center',
    maxWidth: '720px',
    lineHeight: '1.5',
  },
  errorHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
  },
});

export const SubmissionError: React.FC<{ onRetry: () => void }> = ({ onRetry }) => {
  const classes = useErrorStyles();

  return (
    <div className={classes.errorContainer} data-testid="submission-error">
      <div className={classes.errorHeader}>
        <Fail color={ErrorPalette[700]} />
        <p className={classes.errorText} style={{ margin: 0 }}>
          <strong>Submission Error</strong>
        </p>
      </div>
      <p className={classes.errorText}>
        Something went wrong while submitting your consent form, please try again. If this issue persists, please
        contact the Tempus Customer Success team at <a href="mailto:help@tempus.com">help@tempus.com</a> or call{' '}
        <a href="tel:312-598-9961">312-598-9961</a>.
      </p>
      <Button ariaLabel="Retry" onClick={onRetry} data-testid="retry-button">
        Retry
      </Button>
    </div>
  );
};
